export const TOGGLE_ADMIN = 'admin/TOGGLE_ADMIN';
export const OPEN_ADMIN = 'admin/OPEN_ADMIN';
export const SET_CURRENT_USER = 'admin/SET_CURRENT_USER';



// WEBPACK FOOTER //
// ./src/app/containers/Admin/constants.js